













import { Component, Prop, Vue } from 'vue-property-decorator';
import { HOST } from '@/global';
@Component({
  name: 'CertificationLogo',
  components: {}
})
export default class CertificationLogo extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;
}
